export default {
      id: "roller-usage",
      viewBox: "0 0 18 22",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#roller",
      toString: function () {
        return this.url;
      }
    }